import { takeLatest, put, call, all } from "redux-saga/effects";

import { ADVANCED_SEARCH } from "./actionType";

import { advancedSearchSuccess, advancedSearchFailure } from "./action";

import { advancedSearchApiCall } from "../../helpers/fakebackend_helper";

function* runAdvancedSearch({ payload }) {
  try {
    const response = yield call(advancedSearchApiCall, payload);
    yield put(advancedSearchSuccess(response));
  } catch (error) {
    yield put(advancedSearchFailure(error));
  }
}

function* watchAdvancedSearch() {
  yield takeLatest(ADVANCED_SEARCH, runAdvancedSearch);
}

export default function* AdvancedSearch() {
  yield all([watchAdvancedSearch()]);
}
